<!-- V2 VARIANT -->
<ng-container *ngIf="variant === 'v2'; else v3Style">
  <form [formGroup]="form" (ngSubmit)="save()">
  <div class="form__group" [ngClass]="{'form__error': isSubmitting() && f[field.key].errors}">
    <span class="form__label">{{ field.label }} *</span>

    <div class="radioSelectionBox radioSelectionBox--smallP">
      <div class="radioSelectionBox__item" *ngFor="let option of field.options; let i=index">
        <label pRipple class="radioButtonBox" [for]="field.key+'-'+i">
          <p-radioButton [inputId]="field.key+'-'+i" [formControlName]="field.key" [value]="option" (onClick)="save()"></p-radioButton>
          <span class="radioButtonBox__text">{{ option }}</span>
        </label>
      </div>
    </div>

    <span class="form__msgError" *ngIf="isSubmitting() && f[field.key].errors">
      <small class="p-error" *ngIf="f[field.key].hasError('required')">Requerido</small>
    </span>
  </div>
</form>
</ng-container>

<!-- V3 VARIANT -->
<ng-template #v3Style>
  <form [formGroup]="form" (ngSubmit)="save()">
    <div class="form__group">
      <label class="form__label pb-20">{{ field.label }}</label>

      <div class="form__radio">
        <div class="form__radioItem" *ngFor="let option of field.options; let i=index">
          <p-radioButton
            [inputId]="field.key+'-'+i"
            [value]="option"
            [formControlName]="field.key"
            [name]="field.key">
          </p-radioButton>
          <label class="small" [for]="field.key+'-'+i">{{ option }}</label>
        </div>
      </div>

      <span class="form__msgError" *ngIf="isSubmitting() && f[field.key].errors">
        <small class="p-error" *ngIf="f[field.key].hasError('required')">{{ field.label }} es requerido</small>
      </span>
    </div>
  </form>
</ng-template>
